// components/CropModal.jsx
import React, { useCallback, useState } from "react";
import Cropper from "react-easy-crop";
import { Box, Button, Modal, useTheme } from "@mui/material";
import { getCroppedImg } from "../getCroppedImage";
import { useTranslation } from "react-i18next";

export default function CropModal({ open, image, onClose, onCropComplete }) {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const theme = useTheme();
  const { t } = useTranslation();

  const onCropDone = useCallback(async () => {
    const croppedImage = await getCroppedImg(image, croppedAreaPixels);
    onCropComplete(croppedImage);
    onClose();
  }, [image, croppedAreaPixels]);

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "90vw",
          maxWidth: 500,
          bgcolor: "white",
          boxShadow: 24,
          p: 2,
          borderRadius: 2,
        }}
      >
        <Box
          sx={{
            position: "relative",
            width: "100%",
            height: 300,
            background: "#333",
          }}
        >
          <Cropper
            image={image}
            crop={crop}
            zoom={zoom}
            // cropSize={{ width: 400, height: 225 }}
            aspect={16 / 9}
            onCropChange={setCrop}
            onZoomChange={setZoom}
            onCropComplete={(_, croppedPixels) =>
              setCroppedAreaPixels(croppedPixels)
            }
          />
        </Box>

        <Box
          sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mt: 2 }}
        >
          {/* <Button onClick={onClose}>Cancel</Button>
          <Button variant="contained" onClick={onCropDone}>
            Crop
          </Button> */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: { xs: "100%", sm: "fit-content" },
              flexDirection: { xs: "column", sm: "row" },
              gap: { xs: 0.5, sm: 1 },
            }}
          >
            <Button
              variant="outlined"
              sx={{
                border: `1px solid ${theme.palette.text.blue}`,
                width: "100%",
                textTransform: "none",
                borderRadius: "50px",
                fontSize: "18px",
                // color: "#05001B99",
                color: theme.palette.text.blue,
                fontWeight: "600",
                padding: "8px 20px",
                "&:hover": {
                  border: `1px solid ${theme.palette.text.blue}`,
                  backgroundColor: "#fff",
                },
              }}
              onClick={onClose}
            >
              {t("cModal.cancel")}
            </Button>
            <Button
              variant="outlined"
              sx={{
                width: "100%",
                textTransform: "none",
                borderRadius: "50px",
                outline: "none",
                border: "none",
                background: theme.palette.background.lightorange,
                fontSize: "18px",
                color: theme.palette.text.active,
                fontWeight: "600",
                padding: "8px 20px",
                "&:hover": {
                  backgroundColor: theme.palette.text.active,
                  color: theme.palette.background.main,
                },
              }}
              onClick={onCropDone}
            >
              {t("Login.submit")}
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}
